import { Injectable } from '@angular/core';
import { IUserInfoCognito } from './cognito.service';
import { SessionService } from './session.service';
import { environment } from 'src/environments/environment';
import { IReporteMoraPresunta } from 'src/app/models/direccion-trabajo/mora-presunta.model';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ICreateReportF301Payload, IReporteF301 } from 'src/app/models/direccion-trabajo/reporte-f301.model';
import { IReporteMultas } from 'src/app/models/direccion-trabajo/multas.model';

@Injectable({
    providedIn: 'root'
})
export class DireccionTrabajoService {
    private endpoint: string = environment.backend.direccionTrabajo.url;
    private readonly REQUEST_ORIGIN = 'WEB';

    constructor(
        private _sessionService: SessionService,
        private http: HttpClient
    ) { }

    private getHeaders(idOrganizacion: string, idUsuario: string, requestOrigin: string): HttpHeaders {
        const headers = new HttpHeaders()
            .set("IDOrganizacion", idOrganizacion)
            .set("IDUsuario", idUsuario)
            .set("requestOrigin", requestOrigin)

        return headers;
    }

    buildHttpParams(paramsObj?: Record<string, string | null | undefined>): HttpParams {
        let params = new HttpParams();

        if (!paramsObj) return params;

        for (const [key, value] of Object.entries(paramsObj)) {
            if (value != null && value !== '') {
                params = params.set(key, value);
            }
        }

        return params;
    }

    public createMoraPresuntaReport(rut: string): Observable<IReporteMoraPresunta> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const payload = { rut };

        return this.http.post<IReporteMoraPresunta>(`${this.endpoint}moraPresunta`, payload, { headers });
    }

    public createF301Report(payload: ICreateReportF301Payload): Observable<IReporteF301> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);

        return this.http.post<IReporteF301>(`${this.endpoint}f301`, payload, { headers });
    }

    public createMultasReport(rut: string): Observable<IReporteMultas> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const payload = { rut };

        return this.http.post<IReporteMultas>(`${this.endpoint}multas`, payload, { headers });
    }

    public listReports(rut: string, reportType = '') {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ rut, reportType });

        return this.http.get(`${this.endpoint}listar`, { headers, params });
    }

    public searchTX(idTransaccion: string): Observable<any> {

        const userInfo: IUserInfoCognito = this._sessionService.getUserInfo();
        const idUsuario = userInfo.email;
        const idOrganizacion = this._sessionService.getOrganization();

        const headers = this.getHeaders(idOrganizacion, idUsuario, this.REQUEST_ORIGIN);
        const params = this.buildHttpParams({ idTransaccion });

        return this.http.get<any>(`${this.endpoint}buscar`, { headers, params });
    }
}
